export const householdRoutes = [
    {
        path: '/household',
        children: [
          {
            path: 'create',
            component: () => import(/* webpackChunkName: "household" */ '@/features/household/views/HouseholdCreate.vue'),
            meta: { requiresHousehold: false }
          },
          {
            path: 'invitation',
            component: () => import(/* webpackChunkName: "household" */ '@/features/household/views/HouseholdInvitation.vue'),
            meta: { requiresHousehold: false }
          },
          {
            path: 'settings',
            component: () => import(/* webpackChunkName: "household" */ '@/features/household/views/HouseholdSettings.vue'),
            meta: { requiresHousehold: true }
          }
        ]
    }
]
